import React, { Component } from "react";
import styles from "./CalendarSettings.local.scss";
import classnames from "classnames";
import CalendarForm from "./CalendarForm";
import { DateUtils } from "react-day-picker";
import {
  getDatesBetweenDates,
  filterDates,
  filterDatesTagsByOptions,
  onSuccess,
  onError,
  filterCollaboratorDatesTagsByOptions,
  prepareCollaboratorAbsencesForSave,
  isEqualDates,
  isCollaboratorAccess
} from "Utils";
import { MONTHS, STATUS_VACATION } from "Config";
import _ from "i18n";
import clonedeep from "lodash.clonedeep";

class ItemMonth extends Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);

    this.state = {
      selectedDays: { from: undefined, to: undefined },
      activatedOption: null,
      calendarLabel: "",
      backupSelect: null,
      calendarNumeric: "",
      calendarLabelSelect: null
    };
  }

  //
  //   *****************   FUNCTIONS  ***********************
  //

  onChangeCalendarLabel = event => {
    this.setState({
      calendarLabel: event.target.value
    });
  };

  onChangeCalendarNumeric = event => {
    this.setState({
      calendarNumeric: event.target.value
    });
  };

  onSelectCalendarLabel = event => {
    this.setState({
      calendarLabelSelect: event.value
    });
  };

  onSelectBackup = event => {
    this.setState({
      backupSelect: event.value
    });
  };

  handleToggleActivatedMonth = monthNumber => {
    this.props.handleToggleActivatedMonth(monthNumber);
    this.resetCalendar();
  };

  handleDayClick(day, { outside, disabled }) {
    if (outside || disabled) {
      return;
    }

    // set hours, minutes, seconds and milliseconds to 12, to compare the two dates as DATES only without worrying about time elements.
    day.setHours(12, 0, 0, 0);

    const range = DateUtils.addDayToRange(day, this.state.selectedDays);

    if (!range.to) {
      range.to = range.from;
    }

    const { activatedOption } = this.state;
    let list = document.getElementsByClassName("DayPicker-Day--selected");
    if (list.length > 0 && activatedOption) {
      for (let i = 0; i < list.length; i++) {
        list[i].classList.remove("DayPicker-Day--selected--" + activatedOption);
      }
    }

    this.setState({ selectedDays: range, activatedOption: null });
    this.props.setCalendarSelectedDays(range);
  }

  onCalendarOptionClick = option => {
    const { activatedOption } = this.state;
    let list = document.getElementsByClassName("DayPicker-Day--selected");
    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        list[i].classList.remove("DayPicker-Day--selected--" + activatedOption);
        list[i].classList.add("DayPicker-Day--selected--" + option);
      }
    }
    this.setState({
      activatedOption: option
    });

    if (option === "absence_2") {
      this.setState({
        calendarLabelSelect: this.props.holidaysTypes[0].value
      });
    }

    this.props.setCalendarActivatedOption(option);
  };

  //*****************************   FOR ANNUAL CALENDAR  ****************************************
  validateCalendarMonthSetting = () => {
    const {
      selectedDays,
      modifiers,
      activatedOption,
      monthNumber,
      data: { planning }
    } = this.props;
    const { calendarLabel } = this.state;

    let modif = { ...modifiers };

    // const x = { ...planning };
    let plan = clonedeep(planning);
    // let plan = JSON.parse(JSON.stringify(planning));

    if (!selectedDays.from || !selectedDays.to || !activatedOption) {
      return;
    }

    let dates = getDatesBetweenDates(selectedDays.from, selectedDays.to);

    // 1 - clean existing dates
    modif["holidays"] = filterDates(modif["holidays"], dates);
    modif["annualHolidays"] = filterDates(modif["annualHolidays"], dates);
    modif["workingDays"] = filterDates(modif["workingDays"], dates);

    plan = filterDatesTagsByOptions(plan, MONTHS[monthNumber], dates, [
      "holidays",
      "annualHolidays",
      "workingDays"
    ]);

    //* generate key
    let key = Math.random()
      .toString(36)
      .substr(2, 9);

    let defaultLabel = calendarLabel !== "" ? calendarLabel : activatedOption;

    // 2 - ajouter/sync au modifiers et tags
    if (activatedOption !== "workingDays") {
      // -> eliminer les weekend
      if (activatedOption === "annualHolidays") {
        //eslint-disable-next-line array-callback-return
        dates = dates.filter(date => {
          if (![0, 6].includes(date.getDay())) {
            return date;
          }
        });
      }

      // -> ajouter au calendrier
      modif[activatedOption] = [...modif[activatedOption], ...dates];

      // -> ajouter au tags
      dates.forEach((date, i) => {
        plan[activatedOption][MONTHS[monthNumber]].push({
          label: defaultLabel,
          date: date,
          key: key
        });
      });
    } else {
      dates.forEach(date => {
        //* if weekend ouvrable
        if (date.getDay() % 6 === 0) {
          // -> ajouter au calendrier
          modif[activatedOption].push(date);

          // -> ajouter au tags
          plan[activatedOption][MONTHS[monthNumber]].push({
            label: defaultLabel,
            date: date,
            key: key
          });
        }
      });
    }

    this.props
      .saveCalendarSettings(plan, defaultLabel, null, "false", false)
      .then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("Calendrier à jour")
          });
          this.props.setCalendarModifiers(modif);
          this.props.setCalendarPlanning(plan);
          res.value.data.data[0] &&
            this.props.setCalendarId(res.value.data.data[0]);
        },
        err => {
          onError(err.response.data.errors[0].message);
        }
      );

    // 3 - reset selection du calendrier
    this.resetCalendar();
  };

  //***********************  FOR COLLABORATOR CALENDAR  **************************************
  validateCollaboratorCalendarMonthSetting = () => {
    const {
      selectedDays,
      activatedOption,
      modifiers,
      notWorkingDays,
      data: { planning },
      monthNumber,
      holidaysTypes,
      holidaysNbrOfDays,
      seniorityLeave,
      loggedAs,
      spaceAs
    } = this.props;
    const {
      calendarLabel,
      calendarLabelSelect,
      calendarNumeric,
      backupSelect
    } = this.state;
    let communDays = [
      ...modifiers["absence_1"],
      ...modifiers["absence_2"],
      ...modifiers["absence_3"]
    ];

    let modif = { ...modifiers };

    let plan = clonedeep(planning);

    if (!selectedDays.from || !selectedDays.to || !activatedOption) {
      return;
    }

    let dates = getDatesBetweenDates(selectedDays.from, selectedDays.to);

    // 1 - clean existing dates

    modif["absence_1"] = filterDates(modif["absence_1"], dates);
    modif["absence_2"] = filterDates(modif["absence_2"], dates);
    modif["absence_3"] = filterDates(modif["absence_3"], dates);
    dates = filterDates(dates, modif["holidays"]);
    dates = filterDates(dates, modif["annualHolidays"]);

    //eslint-disable-next-line array-callback-return
    dates = dates.filter(date => {
      if (
        modif["workingDays"].find(work => isEqualDates(work, date)) ||
        ![...[0, 6], ...notWorkingDays].includes(date.getDay())
      ) {
        return date;
      }
    });

    if (!plan["absence_1"][MONTHS[monthNumber]]) {
      plan["absence_1"][MONTHS[monthNumber]] = [];
    }
    if (!plan["absence_2"][MONTHS[monthNumber]]) {
      plan["absence_2"][MONTHS[monthNumber]] = [];
    }
    if (!plan["absence_3"][MONTHS[monthNumber]]) {
      plan["absence_3"][MONTHS[monthNumber]] = [];
    }

    plan = filterCollaboratorDatesTagsByOptions(
      plan,
      MONTHS[monthNumber],
      dates,
      ["absence_1", "absence_2", "absence_3"]
    );

    //* generate key
    let key = Math.random()
      .toString(36)
      .substr(2, 9);

    let defaultLabel = calendarLabel !== "" ? calendarLabel : "paidVacation";

    let otherAbsenceLabel =
      calendarLabelSelect &&
      holidaysTypes.filter(type => type.value === calendarLabelSelect)[0].label;

    // 2 - ajouter/sync au modifiers et tags

    // -> ajouter au calendrier
    modif[activatedOption] = [...modif[activatedOption], ...dates];

    // validate holidays Nbr of days!!!
    if (
      activatedOption === "absence_1" &&
      modif["absence_1"].length >
        parseInt(holidaysNbrOfDays.absence_1) +
          parseInt(holidaysNbrOfDays.absence_sl)
    ) {
      // alert("nop");
      onError("Nombre de jours de congé dépassés");
      return;
    }

    //verifie if selected day are not already absences!!!
    let countCommunDays = communDays.filter(day => {
      return (
        selectedDays.from.getMonth() === day.getMonth() &&
        selectedDays.from.getDate() <= day.getDate() &&
        day.getDate() <= selectedDays.to.getDate()
      );
    });
    if (loggedAs === "COLLABORATOR" && countCommunDays.length > 0) {
      onError("Vous ne pouvez pas surcharger les congés existants");
      return;
    }

    // return;
    let absence1Count = 0;
    Object.keys(planning.absence_1).forEach(month => {
      absence1Count = absence1Count + planning.absence_1[month].length;
    });
    let secondKey = Math.random()
      .toString(36)
      .substr(2, 9);

    const label =
      activatedOption === "absence_1"
        ? absence1Count < parseInt(holidaysNbrOfDays.absence_1)
          ? defaultLabel
          : seniorityLeave.label
        : otherAbsenceLabel;
    // -> ajouter au tags
    dates.forEach((date, i) => {
      plan[activatedOption][MONTHS[monthNumber]].push({
        label: label,
        date: date,
        backup: activatedOption === "absence_1" ? backupSelect : null,
        hours: activatedOption === "absence_3" ? calendarNumeric : 8,
        key:
          activatedOption === "absence_1" &&
          absence1Count >= parseInt(holidaysNbrOfDays.absence_1)
            ? secondKey
            : key,
        type:
          activatedOption === "absence_1"
            ? absence1Count < parseInt(holidaysNbrOfDays.absence_1)
              ? 1
              : seniorityLeave.value
            : activatedOption === "absence_3"
              ? 13
              : calendarLabelSelect,
        vacationStatus: isCollaboratorAccess(loggedAs, spaceAs)
          ? STATUS_VACATION.PENDING
          : STATUS_VACATION.APPROVED
      });
      absence1Count = absence1Count + 1;
    });

    let planningDataToSave = prepareCollaboratorAbsencesForSave(
      plan,
      MONTHS[monthNumber],
      monthNumber,
      ["absence_1", "absence_2", "absence_3"]
    );
    this.props
      .saveCalendarSettings(planningDataToSave, label, null, "false", false)
      .then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("Calendrier à jour")
          });
          this.props.refreshCalendar();
          this.props.setCalendarModifiers(modif);
          this.props.setCalendarPlanning(plan);
        },
        err => {
          onError(err.response.data.errors[0].message);
        }
      );
    for (const key in plan) {
      if (key === "absence_2") {
        if (plan.hasOwnProperty(key)) {
          const monthObj = plan[key];
          for (let monthKey in monthObj) {
            if (monthObj.hasOwnProperty(monthKey)) {
              const absenceArray = monthObj[monthKey];
              absenceArray.forEach(element => {
                if (
                  element.label === "Congé Maladie" &&
                  element.vacationStatus === "PENDING"
                ) {
                  element.vacationStatus = "APPROVED";
                }
              });
            }
          }
        }
      }
    }
    // 3 - reset selection du calendrier
    this.resetCalendar();
  };

  resetCalendar = () => {
    this.props.initCalendarSelect();
    this.setState({
      selectedDays: { from: undefined, to: undefined },
      activatedOption: null,
      calendarLabel: ""
    });
  };

  setSelectedTagDataToUpdate = (label, option, dates) => {
    this.props.initCalendarSelect();

    this.setState({
      selectedDays: { from: dates[0], to: dates[dates.length - 1] },
      // activatedOption: option,
      calendarLabel: label
    });
    this.props.setCalendarSelectedDays({
      from: dates[0],
      to: dates[dates.length - 1]
    });
    setTimeout(() => this.onCalendarOptionClick(option), 100);
  };

  //
  //   *****************   RENDERING  ***********************
  //

  renderMonth = () => {
    const {
      month,
      monthNumber,
      lng,
      year,
      active,
      saving,
      attachments
    } = this.props;

    const {
      selectedDays,
      activatedOption,
      calendarLabel,
      backupSelect,
      calendarNumeric,
      calendarLabelSelect
    } = this.state;

    return (
      <div
        className={classnames(
          styles.item_month,
          styles.month_state,
          active ? styles.active : ""
        )}
      >
        <span className={styles.item_label}>{month}</span>

        {active
          ? saving || (selectedDays.from && selectedDays.to && activatedOption)
            ? this.renderValidateUpdatesActions(null, "CREATED")
            : this.renderDefaultActions("opened", monthNumber)
          : this.renderDefaultActions("closed", monthNumber)}

        {active && (
          <CalendarForm
            {...this.props}
            saving={saving}
            monthNumber={monthNumber}
            year={year}
            lng={lng}
            attachments={attachments}
            localSelectedDays={selectedDays}
            activatedOption={activatedOption}
            handleDayClick={this.handleDayClick}
            setCalendarSelectedFiles={this.props.setCalendarSelectedFiles}
            onCalendarOptionClick={this.onCalendarOptionClick}
            inputDisplay={
              selectedDays.from &&
              selectedDays.to &&
              activatedOption &&
              activatedOption === "absence_1"
            }
            selectDisplay={
              selectedDays.from &&
              selectedDays.to &&
              activatedOption &&
              activatedOption === "absence_2"
            }
            numericDisplay={
              selectedDays.from &&
              selectedDays.to &&
              activatedOption &&
              activatedOption === "absence_3"
            }
            onChangeCalendarLabel={this.onChangeCalendarLabel}
            onSelectCalendarLabel={this.onSelectCalendarLabel}
            onChangeCalendarNumeric={this.onChangeCalendarNumeric}
            onSelectBackup={this.onSelectBackup}
            calendarLabel={calendarLabel}
            calendarNumeric={calendarNumeric}
            backupSelect={backupSelect}
            calendarLabelSelect={calendarLabelSelect}
          />
        )}
      </div>
    );
  };

  renderDefaultActions = (status, monthNumber) => {
    return (
      <div
        className={classnames(styles.actions_container, styles.one_action)}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div>
          <span
            className={styles.action}
            onClick={() => this.handleToggleActivatedMonth(monthNumber)}
          >
            <i className={classnames("icon icon-arrow-down", styles.rotate)} />
          </span>
        </div>
      </div>
    );
  };

  renderValidateUpdatesActions = (item, type) => {
    return (
      <div
        className={styles.actions_container}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        {this.props.active && this.props.saving ? (
          <div>
            <span className={styles.action} />
            <span className={styles.action}>
              <img
                src={"/img/icons/tail-spin-green.svg"}
                alt={""}
                className={styles.loading}
              />
            </span>
          </div>
        ) : (
          <div>
            <span
              className={styles.action}
              onClick={() => this.resetCalendar()}
            >
              <img
                src={"/img/icons/reload.svg"}
                className={styles.back_arrow}
                alt={""}
              />
            </span>
            <span
              className={styles.action}
              onClick={() =>
                this.props.currentNavPage === "ANNUAL_CALENDAR_SETTING"
                  ? this.validateCalendarMonthSetting()
                  : this.validateCollaboratorCalendarMonthSetting()
              }
            >
              <img
                src={"/img/icons/check-mark.svg"}
                className={styles.check_mark}
                alt={""}
              />
            </span>
          </div>
        )}
      </div>
    );
  };

  render() {
    return this.renderMonth();
  }
}

export default ItemMonth;



// WEBPACK FOOTER //
// ./src/components/CalendarSettings/ItemMonth.js